import { render, staticRenderFns } from "./BaseBreakout.vue?vue&type=template&id=69453d8c&scoped=true&lang=pug"
import script from "./BaseBreakout.vue?vue&type=script&lang=ts"
export * from "./BaseBreakout.vue?vue&type=script&lang=ts"
import style0 from "./BaseBreakout.vue?vue&type=style&index=0&id=69453d8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69453d8c",
  null
  
)

export default component.exports